// extracted by mini-css-extract-plugin
export default {"root":"PageSpin_root__056zo"};